"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var collection_1 = require("./collection");

function isC8QLQuery(query) {
  return Boolean(query && query.query && query.bindVars);
}

exports.isC8QLQuery = isC8QLQuery;

function isC8QLLiteral(literal) {
  return Boolean(literal && typeof literal.toC8QL === "function");
}

exports.isC8QLLiteral = isC8QLLiteral;

function c8ql(strings) {
  var bindVars = {};
  var bindVals = [];
  var query = strings[0];

  for (var i = 0; i < (arguments.length <= 1 ? 0 : arguments.length - 1); i++) {
    var rawValue = i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1];
    var value = rawValue;

    if (isC8QLLiteral(rawValue)) {
      query += "".concat(rawValue.toC8QL()).concat(strings[i + 1]);
      continue;
    }

    var index = bindVals.indexOf(rawValue);
    var isKnown = index !== -1;
    var name = "value".concat(isKnown ? index : bindVals.length);

    if (collection_1.isC8Collection(rawValue)) {
      name = "@".concat(name);
      value = rawValue.name;
    }

    if (!isKnown) {
      bindVals.push(rawValue);
      bindVars[name] = value;
    }

    query += "@".concat(name).concat(strings[i + 1]);
  }

  return {
    query: query,
    bindVars: bindVars
  };
}

exports.c8ql = c8ql;

(function (c8ql) {
  c8ql.literal = function (value) {
    return {
      toC8QL: function toC8QL() {
        return String(value);
      }
    };
  };
})(c8ql = exports.c8ql || (exports.c8ql = {}));